import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";
import classnames from "classnames";
import styles from "./Footer.module.scss";

type Props = {
  /**
   * A string representing the source URL.
   */
  srcUrl: string;
};

export const FooterUI = ({ srcUrl }: Props) => {
  return (
    <div
      className={classnames(styles["container"], "esi-wrapper")}
      data-testid="footer"
      data-component="Footer"
    >
      <ESIInclude id="web-pdp-scaffold-ui-footer" src={srcUrl} />
    </div>
  );
};
